import Form from '../04-components/form';

const module = 'profile-form',
    selector = {
        base: `.js-${module}`
    };

export default class ProfileForm extends Form {

    constructor(baseElement) {
        super(baseElement);
    }

    onChangeHandler(element) {
        super.onChangeHandler(element);

        const value = element.value === 'True' ? 'toggle_on' : element.value === 'False' ? 'toggle_off' : '';

        dataLayer.push({
            'event': 'change_settings',
            'setting_name': element.name,
            'toggle_status': value,
            'eventCategory': 'settings',
            'eventAction': value,
            'eventLabel': element.name
        });
    }
}

function initProfileForm() {
    document.querySelectorAll(selector.base).forEach((element) => {
        new ProfileForm(element);
    });
}

initProfileForm();